import { render, staticRenderFns } from "./ParentContactList.vue?vue&type=template&id=4c757a16&scoped=true"
import script from "./ParentContactList.vue?vue&type=script&lang=js"
export * from "./ParentContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c757a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c757a16')) {
      api.createRecord('4c757a16', component.options)
    } else {
      api.reload('4c757a16', component.options)
    }
    module.hot.accept("./ParentContactList.vue?vue&type=template&id=4c757a16&scoped=true", function () {
      api.rerender('4c757a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/DynamicMonitor/components/ParentContactList.vue"
export default component.exports